import { render, staticRenderFns } from "./InputAutocomplete2.vue?vue&type=template&id=047d2ece&"
import script from "./InputAutocomplete2.vue?vue&type=script&lang=js&"
export * from "./InputAutocomplete2.vue?vue&type=script&lang=js&"
import style0 from "./InputAutocomplete2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports